import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { ConfigProvider } from "antd";

import authService from "@services/auth.service";

import Login from "@components/Login";
import NotFound from "@components/NotFound";
import Board from "@components/Board"
import ExportPostStats from "@components/board/ExportPostStats";
import ExportChannelStats from "@components/board/ExportChannelStats";
import Query from "@components/board/Query";

const App: React.FC = () => {
    // const location = useLocation();
    // const { token } = theme.useToken();

    useEffect(() => {
        fetch('/meta.json')
            .then(async (response) => {
                try {
                    const meta = await response.json()
                    const latestVersion = meta.version
                    localStorage.setItem('version_latest', String(latestVersion))
                    localStorage.setItem('version_current', String(latestVersion))
                } catch {
                    console.debug('Unknown build version')
                    localStorage.setItem('version_latest', 'DEV')
                    localStorage.setItem('version_current', 'DEV')
                }
            });
    }, [])

    return (
        <div className="App">
            <ConfigProvider theme={{
                token: {
                    colorPrimary: '#9261f1',
                },
                components: {
                    Layout: {
                        siderBg: '#130d1e',
                    },
                    Menu: {
                        darkItemBg: '#130d1e',
                        darkSubMenuItemBg: '#130d1e',
                        // darkItemSelectedBg: '#b88fff',
                        // darkItemHoverColor: '#b88fff',
                        // darkItemDisabledColor: '#b88fff',
                        // darkItemColor: '#b88fff',
                        // darkGroupTitleColor: 'red',
                        // dangerItemActiveBg: 'red',
                        // darkPopupBg: '#170d2b',
                        // itemActiveBg: 'red'
                    }
                },
            }}>
                <Routes>
                    {!authService.isLoggedIn() && (
                        <>
                            <Route path="*" element={<Navigate to={"/user/login"} />} />
                            <Route path="user">
                                <Route path="login" element={<Login />} />
                            </Route>
                        </>
                    )}
                    {authService.isLoggedIn() && (
                        <>
                            {/* 404 */}
                            <Route path="*" element={<NotFound />} />
                            {/* redirect */}
                            <Route path="" element={<Navigate to={"/board/export-channels"} />} />
                            {/* user */}
                            <Route
                                path="user/login"
                                element={
                                    <Navigate to={"/board/export-channels"} />
                                }
                            />
                            {/* board/* */}
                            <Route path="board" element={<Board />}>
                                <Route path="export-posts" element={<ExportPostStats />} />
                                <Route path="export-channels" element={<ExportChannelStats />} />
                                <Route path="query" element={<Query />} />
                                <Route path="" element={<Navigate to={"/board/export-channels"} />} />
                            </Route>
                        </>
                    )}
                </Routes>
            </ConfigProvider>
        </div>
    );
}

export default App;
